import gsap from 'gsap';


export default class Kv{

    constructor(){
        this._init();
    }


    _init(){
        this._intro();
    }


    _intro(){
        this.tl = gsap.timeline();
        this.tl
            .add(this._showBack.bind(this), '+=0.5')
            .add(this._showPerson.bind(this), '+=0.5')
            .add(this._showTitle.bind(this), '+=0.5');
    }

    _showBack(){
        const bgList = [...document.querySelectorAll('.kv__item__bg')];

        bgList.forEach($bg => {
            $bg.classList.add('-active');
        });
    }

    _showPerson(){
        const personList = [...document.querySelectorAll('.kv__item__person')];
        const txtList = [...document.querySelectorAll('.kv__item__text')];

        personList.forEach($person => {
            const _delay = Math.max(0.1, Math.random()) * 500 + 2500;
            setTimeout(()=>{
                $person.classList.add('-active');
            }, _delay);
        });

        txtList.forEach($txt => {
            const _delay = Math.max(0.1, Math.random()/2) * 1000;
            setTimeout(()=>{
                $txt.classList.add('-active');
            }, _delay);
        });
    }

    _showTitle(){
        const $title = document.querySelector('.kv__title');
        $title.classList.add('-active');
    }
}
